import { FiMinus, FiPlus } from "react-icons/fi";
import { FaMagnifyingGlass } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";

const ManageDatabase = () => {
    
    const navigate = useNavigate();

    return (
        <div className="manage-database-container">
            <h2>Manage Database</h2>            
            <div className="manage-database-card-and-button-wrapper">
                <div className="manage-database-card">
                    <div className="manage-database-row-wrapper">
                        <h4>Flow Measurement:</h4>
                        <div className="manage-database-buttons-wrapper">
                            <button className="manage-database-button-delete" onClick={() => navigate('flow-measurement/record')}><FiMinus /></button>
                            <button className="manage-database-button-view" onClick={() => navigate('flow-measurement/choice')}><FaMagnifyingGlass /></button>
                            <button className="manage-database-button-add" onClick={() => navigate('flow-measurement/new')}><FiPlus /></button>
                        </div>
                    </div>
                    <div className="manage-database-row-wrapper">
                        <h4>Flow Meter:</h4>
                        <div className="manage-database-buttons-wrapper">
                            <button className="manage-database-button-delete" onClick={() => navigate('flow-meter/delete')}><FiMinus /></button>
                            <button className="manage-database-button-view" onClick={() => navigate('flow-meter/choice')}><FaMagnifyingGlass /></button>
                            <button className="manage-database-button-add" onClick={() => navigate('flow-meter/new')}><FiPlus /></button>
                        </div>
                    </div>
                    <div className="manage-database-row-wrapper">
                        <h4>Location:</h4>
                        <div className="manage-database-buttons-wrapper">
                            <button className="manage-database-button-delete" onClick={() => navigate('location/delete')}><FiMinus /></button>
                            <button className="manage-database-button-view" onClick={() => navigate('location/choice')}><FaMagnifyingGlass /></button>
                            <button className="manage-database-button-add" onClick={() => navigate('location/new')}><FiPlus /></button>
                        </div>
                    </div>
                    <div className="manage-database-row-wrapper">
                        <h4>Converter:</h4>
                        <div className="manage-database-buttons-wrapper">
                            <button className="manage-database-button-delete" onClick={() => navigate('converter/delete')}><FiMinus /></button>
                            <button className="manage-database-button-view" onClick={() => navigate('converter/choice')}><FaMagnifyingGlass /></button>
                            <button className="manage-database-button-add" onClick={() => navigate('converter/new')}><FiPlus /></button>
                        </div>
                    </div>
                    <div className="manage-database-row-wrapper">
                        <h4>Sensor:</h4>
                        <div className="manage-database-buttons-wrapper">
                            <button className="manage-database-button-delete" onClick={() => navigate('sensor/delete')}><FiMinus /></button>
                            <button className="manage-database-button-view" onClick={() => navigate('sensor/choice')}><FaMagnifyingGlass /></button>
                            <button className="manage-database-button-add" onClick={() => navigate('sensor/new')}><FiPlus /></button>
                        </div>
                    </div>
                </div>
                <button className="manage-database-button" onClick={() => navigate('/choice')}>Choice</button>
            </div>
        </div>
    );
};

export default ManageDatabase;
